import { action, observable } from 'mobx';
import { api } from '../config';

// Components
import SessionStore from './SessionStore';

let obx = observable({
  balance: 0,
  totalBalance: null,
  paymentSessions: [],
  paymentData: {
    type: null,
    startDate: '2000-01-01T00:00:00.000Z',
    endDate: '2070-01-01T00:00:00.000Z',
    payTo: null
  },
  // Reset payment data
  resetPaymentData: action(function(){
    obx.paymentData = {
      type: null,
      startDate: '2000-01-01T00:00:00.000Z',
      endDate: '2070-01-01T00:00:00.000Z',
      payTo: null
    }

    obx.checkUrl = null;
  }),
  location: {},
  // Get balance
  getBalance: action(function(totalBalance, backgroundLoad){
    if(!backgroundLoad) {
      SessionStore.startLoading('Loading…', 'GetBalance');
    } else {
      SessionStore.startBackgroundLoading('GetBalance');
    }

    let query = '';

    if(!totalBalance) {
      query = `?startDate=${obx.paymentData.startDate}&endDate=${obx.paymentData.endDate}`

      if(obx.paymentData.locationSid) {
        query += `&locationSid=${obx.paymentData.locationSid}`
      }
    }

    api.get(`/proctors/${SessionStore.userData.proctorAccountSid}/balance${query}`)
      .then(response => {
        if(totalBalance) {
          obx.totalBalance = response.data.summary.total;
        }

        obx.balance = response.data.summary.total;
        obx.paymentSessions = response.data.results;

        if(!backgroundLoad) {
          SessionStore.finishLoading('GetBalance');
        } else {
          SessionStore.finishBackgroundLoading('GetBalance');
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get payment history
  paymentHistory: [],
  getPaymentHistory: action(function(){
    SessionStore.startLoading('Loading…', 'GetPaymentHistory');

    api.get(`/proctors/${SessionStore.userData.proctorAccountSid}/payments?sortOrder=DESC`)
      .then(response => {
        obx.paymentHistory = response.data.results;
        SessionStore.finishLoading('GetPaymentHistory');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get an individual payment
  selectedPayment: {},
  getPayment: action(function(sid){
    SessionStore.startLoading('Loading…', 'GetPayment');

    obx.selectedPayment = {};

    api.get(`/proctors/${SessionStore.userData.proctorAccountSid}/payments/${sid}`)
      .then(response => {
        obx.selectedPayment = response.data;
        SessionStore.finishLoading('GetPayment');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Validate payment credentials
  validatePayment: action(function(password, errorMsg, callback){
    SessionStore.startLoading('Loading…', 'ValidatePayment');

    let data = {
      password: password,
      username: SessionStore.userData.username
    }

    // Proctors coming over from the old system seem to
    // not have a username property given when they
    // log in with their token, so fall back to the
    // email address if a username is not set
    if(!data.username) {
      data.username = SessionStore.userData.email;
    }

    console.log(data);

    api.post(`/proctors/login`, data)
      .then(response => {
        obx.createPayment(callback);
        SessionStore.finishLoading('ValidatePayment');
      })
      .catch(error => {
        SessionStore.finishLoading('ValidatePayment');
        SessionStore.showDialog(errorMsg);
      })
  }),
  // Generate check
  checkUrl: null,
  createPayment: action(function(callback){
    SessionStore.startLoading('Loading…', 'CreatePayment');

    let data = obx.paymentData;

    if(!data.payTo) {
      data.payTo = `${SessionStore.profile.firstName} ${SessionStore.profile.lastName}`;
    }

    // Insert location data into payment data
    Object.keys(obx.location).forEach(function(key, i){
      if(obx.location[key]) {
        data[key] = obx.location[key];
      }
    });

    if(!data.locationSid) {
      delete data.locationSid;
    }

    api.post(`/proctors/${SessionStore.userData.proctorAccountSid}/payments`, data)
      .then(response => {
        SessionStore.finishLoading('CreatePayment');

        if(data.type === 'online-check') {
          obx.checkUrl = response.data.pdfUrl;
        }

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error)
      })
  })
});

export default obx;



// WEBPACK FOOTER //
// ./src/app/stores/PaymentStore.js